import React, { useEffect, useState } from "react";
import styles from "./AutoPayDetailsContent.module.css";
import { connect, useDispatch } from "react-redux";
import { pushToGA } from "../../Services/users";
import { cancleRecurring } from "../../Services/pgi";
import { tenPercent } from "../../Values/utils";

interface AutoPayDetailsContentProps {
    setAutoPayDetails: (open: boolean) => void;
    historyData?:any
    historyAmount?:any
    historyCredit?:any
    historyVal?:any
    historyUsedCredit?:any
    tranId?:any
    user?:any
}

const AutoPayDetailsContent: React.FC<AutoPayDetailsContentProps> = ({ setAutoPayDetails,historyData,historyAmount,historyCredit,historyVal,historyUsedCredit,tranId,user }) => {

// console.log("tranId AutoPayDetailsContent",tranId)
    const closeHandler = () => {
        setAutoPayDetails(false);
        document.body.classList.remove("no-overflow");
    };

    const cancelAutoPayHandler = (Id:any) => {
        pushToGA(
            "event_tracking",
            "read pro",
            "read pro",
            "Cancel Autopay click",
            user,
        )
        cancleRecurring(Id,user.user_super_oid)
    }

    // console.log("historyAmount",historyAmount)
    // console.log("historyCredit",historyCredit)
    // console.log("historyVal",historyVal)

    return (
        <div className={styles.AtmbilpayContent}>
            <div className={styles.AtmbilpayTitle}>Automatic Bill payment</div>
            <div className={styles.AtmbilpayBillCard}>
                <div className={styles.PlanCardInfoi}>
                    <div className={styles.PlanCardData}><span className={styles.Rupees}>&#8377;</span> {historyAmount}</div>
                </div>
                <div className={styles.PlanCardInfo}>
                    <div className={styles.PlanCardInfoi}>
                        <div className={styles.PlanCardLabel}>Validity</div>
                        <div className={styles.PlanCardData}>{historyVal}</div>
                    </div>
                    <div className={styles.PlanCardInfoi}>
                        <div className={styles.PlanCardLabel}>Credits</div>
                        <div className={styles.PlanCardData}>{historyCredit}</div>
                    </div>
                </div>
                <div className={styles.Terms}>
                {/* Your current package consumption stands at {historyUsedCredit}%. The next payment will be triggered when remaining credits are less than {tenPercent(historyCredit)}. */}
                Your current package consumption stands at {historyUsedCredit}%. The next payment will be triggered when remaining credits are less than 5000.
                </div>
            </div>
            <div className={styles.MarketingPlanCardTitle}>Autopay History</div>
            <div className={styles.MarketingPlanCardList}>
            {historyData?.length > 0 ? (
                historyData.map((data:any, index:any) => (
                    <div key={index} className={styles.MarketingPlanCardListRow}>
                        <span className={styles.MarketingPlanCardListValue}>{data.packageName}</span>
                        <span className={styles.MarketingPlanCardListValue}>
                            {new Date(data.orderDate).toLocaleDateString()}
                        </span>
                        <span className={styles.MarketingPlanCardListValue}>
                            <span className={styles.Rupees}>₹ </span>
                            {data.packageAmount}
                        </span>
                    </div>
                ))
            ) : (
                <div>No transaction history available.</div>
            )}
                {/* <span className={styles.SeeAll}>See All</span> */}
            </div>
            <div className={styles.AtmbilpayActns}>
                <span className={`${styles.AtmbilpayCtaOutlined} CtaOutlined`} onClick={()=>cancelAutoPayHandler(tranId)}>Cancel Autopay</span>
                <span className={`${styles.AtmbilpayCtaFilled} CtaFilled`} onClick={closeHandler}>Close</span>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(AutoPayDetailsContent);